/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  isActive?: boolean;
};

const SvgComponent: FC<IProps> = ({ width = 25, height = 25, isActive }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="ms-0.5"
    width={width}
    height={height}
    viewBox="0 0 25 24"
    fill="none">
    <path d="M11.291 1.58337C10.7385 1.58337 10.2086 1.80287 9.81788 2.19357C9.42718 2.58427 9.20768 3.11417 9.20768 3.66671V8.87504H3.99935C3.44681 8.87504 2.91691 9.09453 2.52621 9.48523C2.13551 9.87594 1.91602 10.4058 1.91602 10.9584V13.0417C1.91602 14.1875 2.85352 15.125 3.99935 15.125H9.20768V20.3334C9.20768 21.4792 10.1452 22.4167 11.291 22.4167H13.3743C13.9269 22.4167 14.4568 22.1972 14.8475 21.8065C15.2382 21.4158 15.4577 20.8859 15.4577 20.3334V15.125H20.666C21.2185 15.125 21.7485 14.9055 22.1392 14.5148C22.5299 14.1241 22.7493 13.5942 22.7493 13.0417V10.9584C22.7493 10.4058 22.5299 9.87594 22.1392 9.48523C21.7485 9.09453 21.2185 8.87504 20.666 8.87504H15.4577V3.66671C15.4577 3.11417 15.2382 2.58427 14.8475 2.19357C14.4568 1.80287 13.9269 1.58337 13.3743 1.58337H11.291Z" stroke={isActive ? "white":"black"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
